import log from 'loglevel';

import { ConversationService } from './conversation.service';

export class DatabaseService {
  public conversations = new ConversationService();

  async init(): Promise<void> {
    try {
      await this.conversations.init();
    } catch (error) {
      log.error('Failed to initialize database:', error);
      throw error;
    }
  }

  async clearAllData(): Promise<boolean> {
    try {
      await this.conversations.clear();
      return true;
    } catch (error) {
      log.error('Failed to clear all data:', error);
      return false;
    }
  }

  async getStats(): Promise<{ conversationCount: number }> {
    try {
      const conversationCount = await this.conversations.getConversationCount();
      return { conversationCount };
    } catch (error) {
      log.error('Failed to get database stats:', error);
      return { conversationCount: 0 };
    }
  }
}

export const databaseService = new DatabaseService();
